module.exports = __webpack_public_path__ + "img/himija.19a41c5c.svg";